// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"d93c3f04","133":"f8507266","182":"2b4b874a"}[chunkId] + ".chunk.js";
};